import { BALANCED_TEAM_PROFILE_SEED_ID } from "@/components/match/match-design-rules";

// The three company-default TeamProfiles ("Power Profil" in the UI), seeded by
// genesis migrations V0004 (Explore, Exploit) and V0047 (Ausgewogen). Their
// name and weights are immutable; genesis deliberately carries no protection
// flag for it (genesis#211), so the lock lives here and only here.
//
// Keyed by id, NOT by name: TeamProfile.name resolves per request locale
// (name_de / name_en), so the balanced profile reads "Ausgewogen" in German and
// "Balanced" in English — a name match would silently unlock all three for an
// English-locale admin. The ids come from the migrations and are therefore
// identical in every environment.
//
// Members stay editable on these profiles; only name and weights are locked.
export const READONLY_TEAM_PROFILE_IDS = [
  "9df4754d-3c71-4487-bd76-3b85563ac0a6", // Explore
  "c0b51fa6-7ba2-40dd-a05c-3deb4653556f", // Exploit
  BALANCED_TEAM_PROFILE_SEED_ID, // Ausgewogen / Balanced
] as const;

export function isReadonlyTeamProfile(id: string): boolean {
  return (READONLY_TEAM_PROFILE_IDS as readonly string[]).includes(id);
}
